import styled, { createGlobalStyle } from 'styled-components';
import { Select, DatePicker } from 'antd';
import { TabsWrapperProps } from 'store/ducks/Reporting/types';
import { IToken } from 'store/ducks/globalTypes';

export const EntitySelect = styled(Select)`
  min-width: 120px;
  margin-right: 8px;
  z-index: 1050;

  .ant-select-dropdown {
    z-index: 99999 !important;
  }

  .ant-select-selector {
    overflow: visible !important;
  }

  .ant-select-item-option {
    white-space: nowrap;
  }
`;

export const StyledDatePicker = styled(DatePicker)`
  width: 120px;
  margin-right: 8px;
`;

export const RisksControlsGapsFilterBar = styled.div`
  max-width: 100%;
  margin-left: 20px;
`;

export const TabsWrapper = styled.div<TabsWrapperProps>`
  .ant-tabs-tab {
    color: ${(props) =>
      props.token.colorText || 'rgba(0, 0, 0, 0.88)'} !important;
  }

  .ant-tabs-tab:hover {
    color: ${(props) =>
      props.token.colorText || 'rgba(0, 0, 0, 0.88)'} !important;
  }

  .ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${(props) => props.token.colorPrimary || '#1890ff'} !important;
  }

  .ant-tabs-tab-btn {
    color: ${(props) =>
      props.token.colorText || 'rgba(0, 0, 0, 0.88)'} !important;
  }
`;

export const risksControlsHeaderStyle = {
  paddingTop: '0px',
  paddingBottom: '0px',
  borderBottom: 'none',
  verticalAlign: 'middle',
  height: '56px',
  position: 'relative'
};

export const risksControlsDateHeaderStyle = {
  paddingTop: '0px'
};

export const risksControlsStartDateCellStyle = {
  borderRight: '1px solid #d9d9d9'
};

export const RisksControlsGapsTableWrapper = styled.div`
  .ant-table-thead > tr:nth-child(2) > th {
    padding: 0;
    height: 0;
    line-height: 0;
    border: 0;
  }

  .ant-table-thead > tr:nth-child(2) > th::before {
    display: none;
    content: none;
  }

  /* Keep filter/search icon directly next to column title */
  .ant-table-thead > tr:first-child > th .ant-table-filter-trigger {
    margin-left: 4px;
    margin-right: 0;
    padding: 0 2px;
  }

  .ant-table-thead > tr:first-child > th .ant-table-filter-column {
    display: flex;
    align-items: center;
    flex-direction: row;
  }

  .ant-table-thead > tr:first-child > th .ant-table-column-title {
    flex: none;
  }
`;

export const Search = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;

  .search-title {
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
  }

  .search-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    flex-shrink: 0;
    transition: color 0.2s ease;
  }

  .search-icon:hover {
    color: #1677ff;
  }

  .search-input {
    width: 120px;
    flex-shrink: 0;
  }

  .search-close {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    flex-shrink: 0;
  }
`;

export const GlobalDatePickerStyle = createGlobalStyle<IToken>`
  .white-bg-datepicker .ant-picker-panel-container {
    background: #ffffff !important;
  }

  .white-bg-datepicker .ant-picker-panel {
    background: #ffffff !important;
  }

  .white-bg-datepicker .ant-picker-date-panel,
  .white-bg-datepicker .ant-picker-body {
    background: #ffffff !important;
  }
`;
